<dialog #dlg class="feedback-modal" aria-label="Send feedback" (close)="onClosed()">
  <div class="feedback-modal__header">
    <span class="feedback-modal__title">Send Feedback</span>
    <button class="feedback-modal__close" (click)="close()" aria-label="Close">
      <lucide-icon [img]="icons.X" [size]="18" />
    </button>
  </div>

  @if (successTicketNumber()) {
    <div class="feedback-modal__success">
      <p>Thank you! Your feedback has been submitted as <strong>{{ successTicketNumber() }}</strong>.</p>
      <p>You can track replies in <em>My Feedback</em> in the sidebar.</p>
      <button class="nx-btn nx-btn--primary" (click)="close()">Done</button>
    </div>
  } @else {
    <div class="feedback-modal__body">
      <div class="feedback-type-selector">
        <button class="feedback-type-btn" [class.active]="type() === 'bug'" (click)="selectType('bug')">Bug Report</button>
        <button class="feedback-type-btn" [class.active]="type() === 'feature'" (click)="selectType('feature')">Feature Request</button>
        <button class="feedback-type-btn" [class.active]="type() === 'question'" (click)="selectType('question')">Question</button>
      </div>

      <label class="nx-field">
        <span class="nx-label">Title <span class="nx-required">*</span></span>
        <input
          class="nx-input"
          type="text"
          [ngModel]="title()"
          (ngModelChange)="title.set($event)"
          placeholder="Brief summary"
          maxlength="120"
        />
      </label>

      <label class="nx-field">
        <span class="nx-label">Description</span>
        <textarea
          class="nx-input nx-textarea"
          rows="4"
          [ngModel]="description()"
          (ngModelChange)="description.set($event)"
          placeholder="What happened? What did you expect?"
        ></textarea>
      </label>

      @if (feedbackSvc.screenshotEnabled()) {
        @if (screenshotPreviewUrl()) {
          <div class="feedback-screenshot-preview">
            <img [src]="screenshotPreviewUrl()" alt="Screenshot preview" />
            <button class="feedback-screenshot-remove" (click)="removeScreenshot()" aria-label="Remove screenshot">
              <lucide-icon [img]="icons.X" [size]="14" />
            </button>
          </div>
        } @else {
          <label class="feedback-attach-btn">
            <lucide-icon [img]="icons.Paperclip" [size]="16" />
            Attach screenshot
            <input
              type="file"
              accept="image/jpeg,image/png,image/gif,image/webp"
              style="display:none"
              (change)="onFileChange($event)"
            />
          </label>
        }
      }

      @if (errorMsg()) {
        <div class="nx-inline-error">
          <lucide-icon [img]="icons.AlertCircle" [size]="16" />
          {{ errorMsg() }}
        </div>
      }

      <div class="feedback-modal__actions">
        <button class="nx-btn nx-btn--ghost" (click)="close()">Cancel</button>
        <button
          class="nx-btn nx-btn--primary"
          (click)="submit()"
          [disabled]="submitting() || uploading()"
        >
          @if (submitting() || uploading()) {
            Sending...
          } @else {
            <lucide-icon [img]="icons.Send" [size]="16" />
            Send Feedback
          }
        </button>
      </div>
    </div>
  }
</dialog>
